import { SecuredClient } from '../../../Core/Api/SecuredClient';
import {
  RequestPasswordResetCommandRequest,
  IRequestPasswordResetCommandRequest,
  ResetPasswordCommandRequest,
  IResetPasswordCommandRequest,
  ChangePasswordCommandRequest,
  IChangePasswordCommandRequest,
  IResendActivationEmailCommandRequest,
  ResendActivationEmailCommandRequest,
} from '../../../Core/Api/Api';

export default class ResendActivationHandler {
  props: any;
  constructor(props) {
    this.props = props;
  }

    ResendActivationEmail(model: IResendActivationEmailCommandRequest) {
    const client = new SecuredClient();
    client.showLoading = true;
    client.handleGeneralError = true;
      const request = new ResendActivationEmailCommandRequest(model);

    return client.resendActivationEmail(request);
  }

}
